import React, { FC, useRef, useState } from 'react';
import ReactPlayer from 'react-player';

import Icon from '../../../Icon';
import UseClickOutSide from '../../../../uses/useClickOutSide';

import { IVideoModal } from './interfaces';

import './styles.scss';

// media videos item modal
const VideoModal: FC<IVideoModal> = ({
  onDuration,
  toggle,
  url
}) => {
  const [ pause, setPause ] = useState<boolean>(false);

  // element
  const element: any = useRef<any>(null);

  // click out
  UseClickOutSide(element, () => toggle());

  // render
  return (
    <div
      className="video-modal"
      ref={element}>
      <div className="video-modal--container">
        <button className="btn-close" onClick={() => toggle()}>
          <Icon icon="icon-times" />
        </button>

        <ReactPlayer
          className="video-modal--video"
          height={470}
          width={835}
          playing={pause}
          url={url}
          onDuration={onDuration}
          onEnded={() => setPause(false)} />

        <div className="loader"></div>
      </div>
    </div>
  );
};

export default VideoModal;